import React from 'react';
import { Link } from 'react-router';
import { legalPageUrl, isAbsoluteLegalUrl } from '../../legal/legalLinks';

const LscFooter: React.FC = () => {
  const termsUrl = legalPageUrl('terms');
  const privacyUrl = legalPageUrl('privacy');
  const year = new Date().getFullYear();

  const renderLink = (label: string, url: string, testId: string) => {
    const className =
      'hover:text-purple-700 dark:hover:text-purple-300 transition-colors underline-offset-2 hover:underline';
    if (isAbsoluteLegalUrl(url)) {
      return (
        <a href={url} className={className} data-testid={testId}>
          {label}
        </a>
      );
    }
    return (
      <Link to={url} className={className} data-testid={testId}>
        {label}
      </Link>
    );
  };

  return (
    <footer
      className="border-t border-slate-200 dark:border-slate-800/80 bg-secondary-900/40 shrink-0"
      data-testid="lsc-footer"
    >
      <div className="w-full px-6 py-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm text-slate-500 dark:text-slate-500">
        <span className="text-slate-600 dark:text-slate-400">Stream Center by Scoutlytics</span>
        <span aria-hidden className="text-slate-300 dark:text-slate-700">
          ·
        </span>
        {renderLink('Terms', termsUrl, 'lsc-footer-terms-link')}
        <span aria-hidden className="text-slate-300 dark:text-slate-700">
          ·
        </span>
        {renderLink('Privacy', privacyUrl, 'lsc-footer-privacy-link')}
        <span aria-hidden className="text-slate-300 dark:text-slate-700">
          ·
        </span>
        <span>© {year} Scoutlytics</span>
      </div>
    </footer>
  );
};

export default LscFooter;
